/*
  Reia: hover or click a gallery thumbnail to switch the desktop PDP gallery
  to it, with video thumbnails playing automatically.

  Desktop PDP gallery (gallery_style: "thumbnails") shows exactly one
  .product__media-item at a time. Previously only click switched which one
  was visible (theme.js's own click listener), and it never started
  playback, so a video thumbnail needed a second click on the video's own
  play button.

  This makes hover do the switching too (mouseenter selects that thumbnail's
  media, same as a click would), and for video thumbnails:
    - Hover: plays muted, as a preview.
    - Click: forces unmuted playback (explicit "yes, with sound" intent) -
      this fires even if hover already started it muted.
    - Playback is NOT tied to the mouse staying over the thumbnail - moving
      the cursor away does nothing, the video just keeps playing. It only
      stops when a *different* thumbnail (image or video) is hovered or
      clicked, at which point that video is paused in place (position kept,
      not reset), so hovering back over it later resumes where it left off.

  Native Shopify video ("video" media type): Shopify.Plyr wraps the
  underlying <video> in-place. Calling video.play() directly on that element
  starts playback but does NOT tell Plyr to dismiss its poster overlay or
  show its control bar - those only update through Plyr's own click
  handling on its overlaid play button (.plyr__control--overlaid). So the
  first play is triggered by clicking that button (letting Plyr manage its
  own poster/controls state correctly, controls included); once dismissed,
  subsequent resumes call video.play() directly since the poster is already
  gone by then.

  External video ("external_video" - YouTube/Vimeo iframes) isn't wrapped
  in a JS player object on this desktop gallery (only the mobile carousel
  gets one), so it's controlled via postMessage instead.
*/
(function () {
  'use strict';

  function postToExternalVideo(iframe, messages) {
    if (!iframe || !iframe.contentWindow) return;
    messages.forEach(function (message) {
      iframe.contentWindow.postMessage(JSON.stringify(message), '*');
    });
  }

  function playExternalVideo(iframe, muted) {
    postToExternalVideo(iframe, [
      { event: 'command', func: muted ? 'mute' : 'unMute', args: [] },
      { method: 'setVolume', value: muted ? 0 : 1 },
      { event: 'command', func: 'playVideo', args: [] },
      { method: 'play' }
    ]);
  }

  function pauseExternalVideo(iframe) {
    postToExternalVideo(iframe, [
      { event: 'command', func: 'pauseVideo', args: [] },
      { method: 'pause' }
    ]);
  }

  function playItem(item, muted) {
    var type = item.dataset.mediaType;
    if (type === 'video') {
      var video = item.querySelector('video');
      if (!video) return;
      video.muted = !!muted;
      var overlay = item.querySelector('.plyr__control--overlaid');
      if (overlay && overlay.offsetParent !== null) {
        // First play - let Plyr's own click handling dismiss the poster and
        // bring up its control bar, instead of just starting the raw video.
        overlay.click();
      } else {
        video.play().catch(function () {});
      }
    } else if (type === 'external_video') {
      playExternalVideo(item.querySelector('iframe'), !!muted);
    }
  }

  function pauseItem(item) {
    var type = item.dataset.mediaType;
    if (type === 'video') {
      var video = item.querySelector('video');
      if (video) video.pause();
    } else if (type === 'external_video') {
      pauseExternalVideo(item.querySelector('iframe'));
    }
  }

  function pauseAllExcept(mediaContainer, exceptItem) {
    mediaContainer.querySelectorAll('.product__media-item').forEach(function (item) {
      if (item !== exceptItem) pauseItem(item);
    });
  }

  function selectItem(mediaContainer, thumbsContainer, item, thumb) {
    mediaContainer.querySelectorAll('.product__media-item').forEach(function (other) {
      if (other !== item) other.classList.add('hidden');
    });
    item.classList.remove('hidden');
    pauseAllExcept(mediaContainer, item);
    thumbsContainer.querySelectorAll('[data-product-thumbnail]').forEach(function (t) {
      t.classList.toggle('active', t === thumb);
    });
  }

  function initGallery(mediaContainer, thumbsContainer) {
    var thumbs = thumbsContainer.querySelectorAll('[data-product-thumbnail]');
    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      var mediaId = thumb.dataset.thumbnailId;
      var item = mediaContainer.querySelector('[data-media-item-id="' + mediaId + '"]');
      if (!item) return;
      var type = item.dataset.mediaType;
      var isVideo = type === 'video' || type === 'external_video';

      thumb.addEventListener('mouseenter', function () {
        selectItem(mediaContainer, thumbsContainer, item, thumb);
        if (isVideo) playItem(item, true);
      });

      thumb.addEventListener('click', function () {
        selectItem(mediaContainer, thumbsContainer, item, thumb);
        if (isVideo) playItem(item, false);
      });
    });
  }

  document.querySelectorAll('.product[data-is-full-product="true"]').forEach(function (product) {
    var mediaContainer = product.querySelector('.product__media-container.above-mobile .product__media');
    var thumbsContainer = product.querySelector('[data-product-thumbnails]');
    if (mediaContainer && thumbsContainer) {
      initGallery(mediaContainer, thumbsContainer);
    }
  });
})();
